'use client';

import Link from "next/link";
import Image from "next/image";
import { urlFor } from "@/sanity/lib/image";
import { Button } from "./ui/button";

export interface BlogPost {
  title: string | null;
  slug: { current?: string | null } | null;
  image: { asset?: { _ref: string; _type: string } } | null;
  description: string | null;
  publishedAt: string | null;
}

interface Props {
  posts: BlogPost[];
}

export default function Blog({ posts }: Props) {
  return (
    <section id="blog" className="scroll-mt-32 max-w-[1350px] mx-auto p-8">
      <h1 className="text-center font-bold text-4xl mb-12">Novinky o broušení</h1>

      <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map((post, index) => (
          <div
            key={post.slug?.current ?? String(index)}
            className="flex flex-col justify-between border border-gray-200 rounded-lg overflow-hidden transition-transform duration-200 ease-in-out hover:shadow-lg hover:-translate-y-2 cursor-pointer"
          >
            {post.image && (
              <Image
                src={urlFor(post.image).width(600).url()}
                alt={post.title ?? ""}
                width={600}
                height={350}
                className="object-cover w-full h-48"
                priority
              />
            )}

            <div className="p-4 flex-grow">
              <h2 className="font-bold text-2xl mb-2">{post.title}</h2>
              <p className="text-gray-500 text-sm mb-4">
                {post.publishedAt ? new Date(post.publishedAt).toLocaleDateString('cs-CZ') : ""}
              </p>
              <p>{post.description}</p>
            </div>

            <div className="p-4 text-right">
              <Link href={`/blog/${post.slug?.current ?? ""}`}>
                <Button className="cursor-pointer">Číst více…</Button>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
